export const FETCH_TIMESHEET_REPORT_DROPDOWNS_REQUEST = "FETCH_TIMESHEET_REPORT_DROPDOWNS_REQUEST";
export const FETCH_TIMESHEET_REPORT_DROPDOWNS_SUCCESS = "FETCH_TIMESHEET_REPORT_DROPDOWNS_SUCCESS";
export const FETCH_TIMESHEET_REPORT_DROPDOWNS_FAILURE = "FETCH_TIMESHEET_REPORT_DROPDOWNS_FAILURE";

export const FETCH_TIMESHEET_REPORT_LIST_REQUEST = "FETCH_TIMESHEET_REPORT_LIST_REQUEST";
export const FETCH_TIMESHEET_REPORT_LIST_SUCCESS = "FETCH_TIMESHEET_REPORT_LIST_SUCCESS";
export const FETCH_TIMESHEET_REPORT_LIST_FAILURE = "FETCH_TIMESHEET_REPORT_LIST_FAILURE";

export const FETCH_TIMESHEET_TASK_STATUS_REPORT_REQUEST = 'FETCH_TIMESHEET_TASK_STATUS_REPORT_REQUEST';
export const FETCH_TIMESHEET_TASK_STATUS_REPORT_SUCCESS = 'FETCH_TIMESHEET_TASK_STATUS_REPORT_SUCCESS';
export const FETCH_TIMESHEET_TASK_STATUS_REPORT_FAILURE = 'FETCH_TIMESHEET_TASK_STATUS_REPORT_FAILURE';

export const FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_REQUEST = 'FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_REQUEST';
export const FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_SUCCESS = 'FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_SUCCESS';
export const FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_FAILURE = 'FETCH_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT_FAILURE';

export const RESET_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT = 'RESET_TIMESHEET_EMPLOYEE_TASK_STATUS_REPORT';

//-------------------------
export const FETCH_TIMESHEET_MONTHLY_REPORT_REQUEST = "FETCH_TIMESHEET_MONTHLY_REPORT_REQUEST";
export const FETCH_TIMESHEET_MONTHLY_REPORT_SUCCESS = "FETCH_TIMESHEET_MONTHLY_REPORT_SUCCESS";
export const FETCH_TIMESHEET_MONTHLY_REPORT_FAILURE = "FETCH_TIMESHEET_MONTHLY_REPORT_FAILURE";


// Project Status Report
export const FETCH_PROJECT_STATUS_REPORT_REQUEST = 'FETCH_PROJECT_STATUS_REPORT_REQUEST';
export const FETCH_PROJECT_STATUS_REPORT_SUCCESS = 'FETCH_PROJECT_STATUS_REPORT_SUCCESS';
export const FETCH_PROJECT_STATUS_REPORT_FAILURE = 'FETCH_PROJECT_STATUS_REPORT_FAILURE';

// Project Details Report
export const FETCH_PROJECT_DETAILS_REPORT_REQUEST = 'FETCH_PROJECT_DETAILS_REPORT_REQUEST';
export const FETCH_PROJECT_DETAILS_REPORT_SUCCESS = 'FETCH_PROJECT_DETAILS_REPORT_SUCCESS';
export const FETCH_PROJECT_DETAILS_REPORT_FAILURE = 'FETCH_PROJECT_DETAILS_REPORT_FAILURE';

// Project Service Report
export const FETCH_PROJECT_SERVICE_REPORT_REQUEST = 'FETCH_PROJECT_SERVICE_REPORT_REQUEST';
export const FETCH_PROJECT_SERVICE_REPORT_SUCCESS = 'FETCH_PROJECT_SERVICE_REPORT_SUCCESS';
export const FETCH_PROJECT_SERVICE_REPORT_FAILURE = 'FETCH_PROJECT_SERVICE_REPORT_FAILURE';

// Module Tasks Report
export const FETCH_MODULE_TASKS_REPORT_REQUEST = 'FETCH_MODULE_TASKS_REPORT_REQUEST';
export const FETCH_MODULE_TASKS_REPORT_SUCCESS = 'FETCH_MODULE_TASKS_REPORT_SUCCESS';
export const FETCH_MODULE_TASKS_REPORT_FAILURE = 'FETCH_MODULE_TASKS_REPORT_FAILURE';

// Employee Details Report
export const FETCH_EMPLOYEE_DETAILS_REPORT_REQUEST = 'FETCH_EMPLOYEE_DETAILS_REPORT_REQUEST';
export const FETCH_EMPLOYEE_DETAILS_REPORT_SUCCESS = 'FETCH_EMPLOYEE_DETAILS_REPORT_SUCCESS';
export const FETCH_EMPLOYEE_DETAILS_REPORT_FAILURE = 'FETCH_EMPLOYEE_DETAILS_REPORT_FAILURE';

// Module Search Report
export const FETCH_MODULE_SEARCH_REPORT_REQUEST = 'FETCH_MODULE_SEARCH_REPORT_REQUEST';
export const FETCH_MODULE_SEARCH_REPORT_SUCCESS = 'FETCH_MODULE_SEARCH_REPORT_SUCCESS';
export const FETCH_MODULE_SEARCH_REPORT_FAILURE = 'FETCH_MODULE_SEARCH_REPORT_FAILURE';

// Project Status List
export const FETCH_PROJECT_STATUS_LIST_REQUEST = 'FETCH_PROJECT_STATUS_LIST_REQUEST';
export const FETCH_PROJECT_STATUS_LIST_SUCCESS = 'FETCH_PROJECT_STATUS_LIST_SUCCESS';
export const FETCH_PROJECT_STATUS_LIST_FAILURE = 'FETCH_PROJECT_STATUS_LIST_FAILURE';

// Project Client Details List
export const FETCH_PROJECT_CLIENT_DETAILS_LIST_REQUEST = 'FETCH_PROJECT_CLIENT_DETAILS_LIST_REQUEST';
export const FETCH_PROJECT_CLIENT_DETAILS_LIST_SUCCESS = 'FETCH_PROJECT_CLIENT_DETAILS_LIST_SUCCESS';
export const FETCH_PROJECT_CLIENT_DETAILS_LIST_FAILURE = 'FETCH_PROJECT_CLIENT_DETAILS_LIST_FAILURE';

// Project Employee Details
export const FETCH_PROJECT_EMPLOYEE_DETAILS_REQUEST = 'FETCH_PROJECT_EMPLOYEE_DETAILS_REQUEST';
export const FETCH_PROJECT_EMPLOYEE_DETAILS_SUCCESS = 'FETCH_PROJECT_EMPLOYEE_DETAILS_SUCCESS';
export const FETCH_PROJECT_EMPLOYEE_DETAILS_FAILURE = 'FETCH_PROJECT_EMPLOYEE_DETAILS_FAILURE';

// Project Client List
export const FETCH_PROJECT_CLIENT_LIST_REQUEST = 'FETCH_PROJECT_CLIENT_LIST_REQUEST';
export const FETCH_PROJECT_CLIENT_LIST_SUCCESS = 'FETCH_PROJECT_CLIENT_LIST_SUCCESS';
export const FETCH_PROJECT_CLIENT_LIST_FAILURE = 'FETCH_PROJECT_CLIENT_LIST_FAILURE';

export const FETCH_PROJECT_STATUS_EXPORT_REQUEST = 'FETCH_PROJECT_STATUS_EXPORT_REQUEST';
export const FETCH_PROJECT_STATUS_EXPORT_SUCCESS = 'FETCH_PROJECT_STATUS_EXPORT_SUCCESS';
export const FETCH_PROJECT_STATUS_EXPORT_FAILURE = 'FETCH_PROJECT_STATUS_EXPORT_FAILURE';